/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.1
 * @since 1.14.0
 */

import styled from 'styled-components';

import { FormLabelStyled } from '../../../../../../components/common/FormStyled/FormStyled';
import { colors, fonts } from '../../../../../../theme';

export const ManageNumberStyled = styled.div.attrs({
    className: 'manage-number',
})`

    .manage-number__parameters {
        display: grid;
        grid-template-columns: 50% 50%;
        gap: 32px;

        padding-bottom: 32px;
        margin-bottom: 32px;
        border-bottom: 1px solid ${colors.borderColorSeparate};
    }
`;

export const ManageNumberLabelsStyled = styled.div.attrs({
    className: 'manage-number__labels',
})`
    .manage-number__label-item {
        display: flex;
        align-items: center;

        margin-bottom: 4px;
    }

    .manage-number__label-color {
        width: 8px;
        height: 8px;
        margin-left: 0;
        margin-right: 8px;
    }

    .manage-number__btn {
        margin-top: 24px;
    }

    .manage-number__show-all {
        display: block;
        width: fit-content;
        margin-top: 12px;
    }
`;

export const ManageNumberPositionStyled = styled.div.attrs({
    className: 'manage-number__position',
})`
    .manage-number__position-container {
        display: flex;
        align-items: center;
        margin-bottom: 24px;

        .drop-down-filter {
            flex-grow: 1;
            width: 260px;
            margin-right: 16px;
        }
    }

    .manage-number__position-modal {
        width: 300px;

        .position-modal__btn {
            width: 100%;
            margin-top: 16px;

            button {
                width: 100%;
            }
        }
    }

    .manage-number__position-save {
        margin-right: 16px;
    }

    /* Select style overwrite */

    .input__container.select__search-input {
        padding: 16px;
    }

    .select__select-list {
        padding: 0;
        border-top: 1px solid ${colors.borderColorDisabled};
        box-sizing: content-box;
    }
`;

export const ManageNumberSimCardStyled = styled.div.attrs({
    className: 'manage-number__sim-card',
})`
    grid-column-start: 1;

    .sim-card__item:not(:last-child) {
        margin-bottom: 12px;
    }

    .sim-card__change {
        margin-top: 24px;
    }
`;

export const ManageNumberRedirectionStyled = styled.div.attrs({
    className: 'manage-number__redirection',
})`
    .redirection__header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
    }

    .redirection__control {
        display: flex;
        align-items: center;

        > *:not(:last-child) {
            margin-right: 24px;
        }
    }
`;

export const ManageNumberRedirectionModalAddStyled = styled.div.attrs({
    className: 'manage-number__redirection-add',
})`
    ${FormLabelStyled} {
        margin-bottom: 4px;
    }

    .select__select-list {
        max-width: 100%;
    }
`;

export const ManageNumberSimCardNoDataStyled = styled.div.attrs({
    className: 'sim-card__no-data',
})`
    position: relative;
    height: 1px;

    > * {
        position: absolute;
        top: -12px;
        ${fonts.textSmall};
        color: ${colors.textColorDanger};
    }
`;
